import React from 'react';
import { useMutation } from '@tanstack/react-query';
import { addAppComponentQuery } from '../apis';
import { toast } from 'react-toastify';

const useAddAppComponent = () => {
  const mutate = useMutation({
    mutationFn: addAppComponentQuery,
    onSuccess() {
      toast.success('Add App Component successfully');
    },
    onError(error) {
      const message = error?.response?.data?.message ?? 'Server error';
      toast.error(message);
      console.error('Error add app component:', error);
    },
  });

  return mutate;
};

export default useAddAppComponent;
